// external modules
import { useTranslation } from "react-i18next";
// components
import SubTitle from "../@common/SubTitle/SubTitle";
import Title from "../@common/Title/Title";
import ImageRenderer from "components/@common/ImageRenderer/ImageRenderer";

// styles & types & assets
import blog from "assets/img/@intro/blog.webp";
import styles from "./Step5.module.scss";

export default function Step5() {
  const { t } = useTranslation();
  return (
    <section className={styles["wrapper-step5"]}>
      <div className={styles["wrap-title"]}>
        <SubTitle>{t("매일 업로드되는 두피 상식")}</SubTitle>
        <Title>{t("맞춤 두피 정보")}</Title>
      </div>
      <div className={styles["wrap-blog"]}>
        <ImageRenderer src={blog} alt={"blog"} />
      </div>
    </section>
  );
}
